import { FieldDefinition } from "./fieldDefinitions";

export interface RehabFacilityDto {
  rehabFacId: number;
  rehabName: string;
  secretariatInfo?: string;
}
export const rehabFacIdKey = "rehabFacId" as const;

export const rehabFacilityFields: FieldDefinition[] = [
  {
    name: "rehabName",
    label: "Όνομα Κέντρου Αποκατάστασης",
    type: "text",
    required: true,
  },
  {
    name: "secretariatInfo",
    label: "Πληροφορίες Γραμματείας",
    type: "text",
    required: false,
  },
] as const;

export const diseaseFilters = rehabFacilityFields.filter((f) =>
  ["rehabName", "secretariatInfo"].includes(f.name),
);

export const rehabFacilityFormData: string[] = ["rehabName", "secretariatInfo"];
